var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6H6C4.34315 6 3 7.34315 3 9V19C3 20.6569 4.34315 22 6 22H14C15.6569 22 17 20.6569 17 19V18H15V19C15 19.5523 14.5523 20 14 20H6C5.44772 20 5 19.5523 5 19V9C5 8.44772 5.44772 8 6 8H7V6Z",
    fill: "#6F767E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9902 7C20.9967 7.08042 21 7.16136 21 7.24264V15C21 16.6569 19.6569 18 18 18H10C8.34315 18 7 16.6569 7 15V5C7 3.34315 8.34315 2 10 2H15.7574C15.8386 2 15.9196 2.0033 16 2.00982V2L16.0107 2.01071C16.7136 2.07025 17.3761 2.3761 17.8787 2.87868L20.1213 5.12132C20.6239 5.6239 20.9298 6.28645 20.9893 6.98929L21 7H20.9902ZM18 16H10C9.44772 16 9 15.5523 9 15V5C9 4.44772 9.44772 4 10 4H15.7574C15.8399 4 15.9213 4.01019 16 4.02988V5C16 6.10457 16.8954 7 18 7H18.9701C18.9898 7.07871 19 7.16015 19 7.24264V15C19 15.5523 18.5523 16 18 16Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.d039f698fabd790b40f57a1f5bba1f01.svg";
export { ForwardRef as ReactComponent };